module.exports = __webpack_public_path__ + "static/media/03.139a88d6.jpg";